import React from 'react';
import { useMedicalCenter } from '../../context/MedicalCenterContext';



const SelectedMedicalCenter = () => {
  const { selectedMedicalCenter } = useMedicalCenter();
  if (!selectedMedicalCenter) return null;

  const label = selectedMedicalCenter.name || shortId(selectedMedicalCenter.id);

  return (
    <div className="mb-4">
      <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium border border-blue-100">
        <span className="mr-2">Medical Center:</span>
        <span className="font-semibold">{label}</span>
      </div>
    </div>
  );
};

export default SelectedMedicalCenter;